
























import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';

@Component({components: {}})
export default class List extends Slide {
  get subType() {
    if (this.section.SubType === 'custom') {
      return '';
    }
    return this.section.SubType;
  }

  get type() {
    switch (this.subType) {
      case 'recommendation':
      case 'cashflowRecommendation':
        return 'layer';
    }
    return 'light-bg';
  }

  get title() {
    switch (this.section.SubType) {
      case 'cashflowMethod1':
        return 'Vad?';
      case 'cashflowMethod2':
        return 'Vilka?';
      case 'cashflowMethod3':
        return 'Varför?';
      case 'cashflowMethod4':
        return 'Metod';
      case 'cashflowMethod5':
        return 'Indirekt metod';
      case 'cashflowMethod6':
        return 'Metodik';
      case 'cashflowMethod7':
        return 'Kategorisering';
      case 'cashflowRecommendation':
        return '';
      case 'cashflowRecommendation_daytoday':
      case 'cashflowRecommendation_workingcapital':
      case 'cashflowRecommendation_investments':
      case 'cashflowRecommendation_financing':
        return 'Fokus';
      case 'yearendNotes':
        return 'Noteringar';
      case 'yearendCovid':
        return 'Covid-19';
      case 'completion':
        return 'Avslutning';
      case 'company_agenda':
        return 'Agenda';
      case 'sustainability':
        return 'Hållbarhet';
      case 'industryAnalysisAgenda':
      case 'competitorAnalysisAgenda':
        return 'Agenda';
      case 'industryAnalysisConditions':
      case 'competitorAnalysisConditions':
        return 'Förutsättningar';
      case 'industryAnalysisCompassInfo':
      case 'competitorAnalysisCompassInfo':
        return 'Bolagskompass';
      case 'impressions':
        return 'Konsultintryck';
      case 'preClosingMeeting_thisYear':
        return 'Noteringar';
      case 'preClosingMeeting_remaining':
        return 'Helårsprognos';
      case 'preClosingMeeting_misc':
        return 'Övrigt';
    }

    return this.section.Title;
  }

  get items() {
    // tslint:disable:max-line-length
    switch (this.section.SubType) {
      case 'cashflowMethod1':
        return [{Value: 'Följa betalningsströmmar', Marked: false}, {Value: 'In- och utbetalningar', Marked: false}, {Value: 'Skillnaden i likvida medel', Marked: false}];
      case 'cashflowMethod2':
        return [{Value: 'Stora bolag måste', Marked: false}, {Value: 'Alla bolag borde', Marked: true}];
      case 'cashflowMethod3':
        return [{Value: 'Var kommer pengarna ifrån', Marked: false}, {Value: 'Vart tar pengarna vägen?', Marked: true}, {Value: 'Optimera likviditeten', Marked: false}];
      case 'cashflowMethod4':
        return [{Value: 'Direkt metod', Marked: false}, {Value: 'Indirekt metod', Marked: true}];
      case 'cashflowMethod5':
        return [{Value: 'Resultaträkning', Marked: false}, {Value: 'Balansräkning', Marked: false}];
      case 'cashflowMethod6':
        return [{Value: 'Justera för ej likviditetspåverkan', Marked: false}, {Value: 'Schablonmässig kategorisering', Marked: false}, {Value: 'Stämma av nettoförändringen', Marked: false}];
      case 'cashflowMethod7':
        return [{Value: 'Operativa kassaflöden', Marked: false}, {Value: 'Förändring rörelsekapital', Marked: false}, {Value: 'Investeringar', Marked: false}, {Value: 'Finansiering', Marked: false}];
      case 'cashflowRecommendation':
        return  [{Value: 'Fokusområde', Marked: true}];
      case 'cashflowRecommendation_daytoday':
      case 'cashflowRecommendation_workingcapital':
      case 'cashflowRecommendation_investments':
      case 'cashflowRecommendation_financing':
        return [
            {Value: 'Operativ verksamhet', Marked: this.section.SubType === 'cashflowRecommendation_daytoday'},
            {Value: 'Rörelsekapital', Marked: this.section.SubType === 'cashflowRecommendation_workingcapital'},
            {Value: 'Investeringar', Marked: this.section.SubType === 'cashflowRecommendation_investments'},
            {Value: 'Finansiering', Marked: this.section.SubType === 'cashflowRecommendation_financing'}];

      case 'company_agenda':
        return [{Value: 'Översikt', Marked: false}, {Value: 'Resultaträkning', Marked: false}, {Value: 'Balansräkning', Marked: false}, {Value: 'Bolagskompass', Marked: false}];

      case 'industryAnalysisAgenda':
      case 'competitorAnalysisAgenda':
        return [{Value: '1. Förutsättningar', Marked: false}, {Value: '2. Jämförelse', Marked: false}, {Value: '3. Summering', Marked: false}, {Value: '4. Nästa steg', Marked: false}];
      case 'industryAnalysisConditions':
        return [{Value: 'Paketerad tjänst', Marked: false}, {Value: this.source, Marked: false, title: this.sourceTitle}, {Value: this.sni, Marked: false, title: 'SCB Branschnyckeltal:'}];
      case 'competitorAnalysisConditions':
        return this.competitors;
      case 'industryAnalysisCompassInfo':
      case 'competitorAnalysisCompassInfo':
        return [{Value: 'Indexerade nyckeltal', Marked: false}, {Value: 'Jämförbarhet över tid', Marked: false}, {Value: 'Storleksoberoende', Marked: false}, {Value: 'Visualisering av balans- och resultaträkning', Marked: false}];
    }

    if (!this.section.Items) {
      return [];
    }
    return this.section.Items;
  }

  get sourceTitle() {
    if (this.data.SieAggVersion > 0) {
      return 'SIE-import:';
    } else {
      return 'Årsredovisning:';
    }
  }

  get competitors() {
    if (this.overviewC2) {
      return [{Value: 'Paketerad tjänst', Marked: false}, {Value: this.source, Marked: false, title: this.sourceTitle}, {Value: this.overviewC1.NAME, Marked: false, title: 'Konkurrent:'}, {Value: this.overviewC2.NAME, Marked: false, title: 'Konkurrent:'}];
    } else {
      return [{Value: 'Paketerad tjänst', Marked: false}, {Value: this.source, Marked: false, title: this.sourceTitle}, {Value: this.overviewC1.NAME, Marked: false, title: 'Konkurrent:'}];
    }
  }

  get source() {
    return `${this.overview.NAME} (${this.balance.sheets[0].DATE_TO.substr(0, 7)})`;
  }

  get sni() {
    return `SNI-kod: ${this.data.Bransch}. ${this.data.BranschText}`;
  }
}
